import { CheckIcon } from '@heroicons/react/24/outline'
import { Badge } from 'shared/atoms'
import type { BadgeVariant } from 'shared/atoms/Badge/Badge'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'
import { useStatusOptions } from '../../hooks/useStatusOptions'
import type { PayoutStatus as PayoutStatusType } from '../../types/payouts.types'

type PayoutStatusProps = WithClassName<{
	status: PayoutStatusType
}>

const STATUS_VARIANTS: Record<PayoutStatusType, BadgeVariant> = {
	init: 'muted',
	requested: 'warning',
	processing: 'primary',
	paid: 'success',
	cancelled: 'danger'
}

export const PayoutStatus = ({ status, className }: PayoutStatusProps) => {
	const statusOptions = useStatusOptions()
	const label = statusOptions.find((option) => option.value === status)?.label ?? status

	if (status === 'paid') {
		return (
			<span
				className={cn(
					'inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-success/40 bg-success-soft px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-success',
					className
				)}>
				<CheckIcon className="h-3 w-3 stroke-[3]" />
				{label}
			</span>
		)
	}

	return (
		<Badge
			variant={STATUS_VARIANTS[status] ?? 'muted'}
			className={cn('px-2.5 text-[11px]', className)}>
			{label}
		</Badge>
	)
}
